import React, { useEffect, useMemo, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import user from "../../assets/user.gif";
import {
  Autocomplete,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import toast from "react-hot-toast";
import formatdate from "../../common/Formatdate";

const Detail = ({ label, value, valueClass = "" }) => (
  <p className="text-gray-700">
    <span className="font-medium">{label}:</span>{" "}
    <span className={`${valueClass}`}>{value || "--"}</span>
  </p>
);

const Bulkapproval = ({ setActiveItem }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const pettyCashStatusTypes = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashStatus;
  const token = localStorage.getItem("token");
  // delete pettyCashStatusTypes?.inverted;
  const pettyCashType = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashTypes;
  const subCategoryTypeinModule =
    pettyCashType?.inverted?.pickupAndDeliveryReimbursement;
  const pettyCashCategoryType = JSON.parse(
    localStorage.getItem("catalogValues")
  ).pettyCashTypes;
  delete pettyCashCategoryType?.inverted;
  const resourceTypes = JSON.parse(
    localStorage.getItem("catalogValues")
  ).resourceTypes;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const particularType = Number(
    JSON.parse(localStorage.getItem("catalogValues")).pettyCashStatus?.inverted
      ?.verified
  );
  const categoryType = JSON.parse(localStorage.getItem("catalogValues"))
    .pettyCashTypes?.inverted?.pickupAndDeliveryReimbursement;

  const [cities, setCities] = useState(null);
  const [city, setCity] = useState("");
  const [showDrawer, setShowDrawer] = useState(false);
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState("");
  const [executiveId, setExecutiveId] = useState(null);
  const [totalCount, setTotalCount] = useState(null);
  const [userList, setUserList] = useState([]);
  const [userName, setUserName] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [statusType, setStatusType] = useState(null);
  const [vehicleListings, setVehicleListings] = useState([]);
  const [pettycashDetail, setPettycashDetail] = useState(null);
  const [vehicleId, setVehicleId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [inputValues, setInputValues] = useState({
    amount: null,
    paymentmethod: null,
    transactionid: null,
    transactionnote: null,
  });
  const [subCategory, setSubCategory] = useState([]);
  const [transactionImage, setTransactionImage] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedAmount, setSelectedAmount] = useState([]);
  const [approvalDetails, setApprovalDetails] = useState(null);
  const [comment, setComment] = useState(null);
  const [cashDetails, setCashDetails] = useState(null);

  const getApprovalDetails = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/pettycashapprovalconfigs?limit=100`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setApprovalDetails(data?.entities?.rows);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching get common transactions:", error);
    }
  };

  useEffect(() => {
    getApprovalDetails();
  }, []);

  const handleSelectAll = () => {
    const allIds = tableData.map((item) => item.id);
    setSelectedRows(allIds);
    const allAmounts = tableData.map((item) => item.amount);
    setSelectedAmount(allAmounts);
  };

  const handleSelectNone = () => {
    setSelectedRows([]);
    setSelectedAmount([]);
  };

  const toggleRowSelection = (id, amount) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
    setSelectedAmount((prev) => [...prev, amount]);
  };

  const isSelected = (id) => selectedRows.includes(id);

  const today = new Date();
  today.setHours(23, 59, 59, 999); // Clear time to midnight

  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);

  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  const modeofPayments = {
    cash: "Cash",
    cheque: "Cheque",
    upi: "UPI",
    netbanking: "Net Banking",
    creditcard: "Credit Card",
    debitcard: "Debit Card",
  };

  function formatDateForApi(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formattedStartDate = formatDateForApi(selectionRange?.startDate);
  const formattedEndDate = formatDateForApi(selectionRange?.endDate);

  const handleReject = async (status, req) => {
    let payload;
    if (status) {
      payload = {
        id: req?.id,
        approvalComment: null,
        approvedBy: profile?.name,
        approvedByEmail: profile?.email,
        pettyCashStatus: status && status,
        issueId: req?.issueId || null,
        pettyCashCode: req?.pettyCashCode,
        amount: req?.amount,
        approvalAttachments: req?.attachments,
      };
    }

    try {
      const response = await fetch(`${apiUrl}/api/pettycashes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data) {
        setPettycashDetail(data?.entityValue);
        getTableData();
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching post pettycash:", error);
    }
  };

  const getPettycashDetails = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/pettycashes/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        setCashDetails(data?.entityValue);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    if (selectedRows) {
      getPettycashDetails(selectedRows[0]);
    }
  }, [selectedRows]);

  const handleApproveCashRequest = async (status) => {
    if (
      !isUserAuthorizedForAmount(
        selectedAmount.reduce((sum, value) => sum + value, 0),
        approvalDetails,
        profile?.id
      )
    ) {
      toast.error("You are not authorized to approve this transaction.");
      return;
    }
    let payload;
    if (status) {
      payload = {
        id: cashDetails?.id,
        approvalComment: comment,
        approvedBy: profile?.name,
        approvedByEmail: profile?.email,
        pettyCashStatus: status && status,
        issueId: cashDetails?.issueId || null,
        pettyCashCode: cashDetails?.pettyCashCode,
        amount: selectedAmount.reduce((sum, value) => sum + value, 0),
        approvalAttachments: null,
        updateIds: selectedRows,
      };
    }

    try {
      const response = await fetch(`${apiUrl}/api/pettycashes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPettycashDetail(data?.entityValue);
        getTableData();        
      } else {
        toast.error(data?.msg);
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching post pettycash:", error);
    }
  };

  const addTransaction = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${apiUrl}/api/petty-cash/bulk-transaction-update`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            transactionDetails: {
              resourceType: resourceTypes?.inverted?.["pettyCashes"],
              // resourceId: cashDetails?.id,
              transactionId: inputValues?.transactionid, // dynamic
              transactionCharges: inputValues?.transactionCharges, // dynamic
              modeOfPayment: inputValues?.paymentmethod, // dynamic
              transactionAmount: inputValues?.amount, // dynamic
              transactionRemark: inputValues?.transactionnote || null, // dynamic
              transactionType: "debit",
              attachments: JSON.stringify(transactionImage || []),
            },
            updateIds: selectedRows,
          }),
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPettycashDetail(data?.entityValue);
        // getTableData();
        setInputValues({
          amount: null,
          paymentmethod: null,
          transactionid: null,
          transactionnote: null,
        });
        setTransactionImage(null);
        toast.success("Transaction Record Added Successfully");
        // getTransactionDetailsApi()
        setActiveItem("Petty Cash Dashboard");
      } else {
        console.error("Unexpected API response:", data);
        toast.error("Something Went Wrong try again");
      }
    } catch (error) {
      console.error("Error fetching post pettycash:", error);
    }
  };

  const isUserAuthorizedForAmount = (amount, approvalDetails, userId) => {
    const eligibleConfigs = approvalDetails?.filter(
      (config) => amount <= config.amount
    );
    let allApprovalIds = [];
    eligibleConfigs?.forEach((config) => {
      try {
        const ids = JSON.parse(config.approvalIds || "[]").map(Number);
        allApprovalIds = allApprovalIds.concat(ids);
      } catch {}
    });
    return [...new Set(allApprovalIds)].includes(userId);
  };

  const subCategoryType = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/catalogs/get-all?parentId=${subCategoryTypeinModule}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setSubCategory(data?.entities?.rows);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching get transaction details:", error);
    }
  };

  // const getTransactionDetailsApi = async () => {
  //   try {
  //     const response = await fetch(
  //       `${apiUrl}/api/commontransactions?resourceType=${593}&resourceId=${1077,1076}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //         },
  //       }
  //     );
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       // setTransactionDetails(data?.entities?.rows);
  //     } else {
  //       console.error("Unexpected API response:", data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching get transaction details:", error);
  //   }
  // };

  const getTableData = async () => {
    if (!formattedStartDate || !formattedEndDate)
      return toast.error("Date is mandatory to filter");

    // if (!executiveId) return toast.error("Select Exective Name");

    try {
      let query = `startDate=${formattedStartDate}&endDate=${formattedEndDate}&pettyCashStatus=${particularType}&cashFor=${categoryType}`;

      if (city && hub) {
        query += `&cityId=${city}&hubId=${hub}`;
      }

      if (vehicleId) {
        query += `&vehicleId=${vehicleId?.id}`;
      }

      // if (categoryId) {
      //   query += `&cashFor=${categoryId}`;
      // }

      if (executiveId) {
        query += `&createdBy=${executiveId?.id}`;
      }

      const response = await fetch(
        `${apiUrl}/api/petty-cash/get-all?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const data = await response.json();
      if (data?.statusCode === "0100") {
        setTableData(data?.entities?.rows);
        setTotalCount(data?.entities?.totalCount || 0);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching petty cash Table Data:", error);
    }
  };

  const viewPettycashDetail = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/pettycashes/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        setPettycashDetail(data?.entityValue);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching View petty cash details:", error);
    }
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setCity(value);
    getHubNames(value);
  };

  const handleHubChange = (event) => {
    const value = event.target.value;
    setHub(value);
  };

  const getUsersLimitDetails = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=1000&isSystemUser=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const userData = data?.entities?.rows;
        let filterTheData = userData.map((item, index) => ({
          id: item?.id,
          name: item?.name,
          email: item?.email,
        }));
        setUserList(filterTheData);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error(
        "Error fetching user limits list in the fuel details tab:",
        error
      );
    }
  };

  const getHubNames = async (value) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/hubs?limit=100&cityId=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setHubs(data?.entities?.rows);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching hub Names:", error);
    }
  };

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        setCities(data);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const handleUploadImage = async (event) => {
    const files = event.target.files;
    const formData = new FormData();
    formData.append("entityName", "pettyCash");
    formData.append("fileTags", "vehicle");
    Object.values(files).forEach((file) => {
      formData.append("files", file);
    });

    try {
      const response = await fetch(`${apiUrl}/fileapi/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data) {
        setTransactionImage(data?.uploaded);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  // const handleStatusChange = (event) => {
  //   const value = event.target.value;
  //   setStatusType(value);
  // };

  const handleCategoryChange = (event) => {
    const value = event.target.value;
    setCategoryId(value);
  };

  useEffect(() => {
    getCityNames();
    getUsersLimitDetails();
    subCategoryType();
  }, []);

  const parsedAttachments = useMemo(() => {
    try {
      return JSON.parse(pettycashDetail?.attachments || "[]");
    } catch (err) {
      console.error("Attachment JSON error", err);
      return [];
    }
  }, [pettycashDetail?.attachments]);

  return (
    <>
      {showDrawer && (
        <div
          className="fixed inset-0 z-[9999] bg-black bg-opacity-40 flex justify-end"
          onClick={() => {
            setShowDrawer(false);
            setPettycashDetail(null);
          }}
        >
          <div
            className="relative h-full w-full max-w-md bg-white shadow-xl p-6 overflow-y-auto z-[10000] transition-all"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-6 border-b pb-3">
              <h2 className="text-2xl font-semibold text-gray-800">
                Request Details
              </h2>
              <button
                onClick={() => setShowDrawer(false)}
                className="text-gray-500 hover:text-gray-800 text-xl"
                aria-label="Close"
              >
                ✕
              </button>
            </div>

            {/* Details */}
            <div className="space-y-4 grid grid-cols-1 md:grid-cols-2 text-sm text-gray-700">
              <Detail label="ID" value={pettycashDetail?.id} />
              <Detail
                label="Title"
                value={pettyCashCategoryType[pettycashDetail?.cashFor]}
              />
              <Detail
                label="Description"
                value={pettycashDetail?.description}
              />
              <Detail label="Amount" value={`₹ ${pettycashDetail?.amount}`} />
              <Detail
                label="Booking Code"
                value={
                  pettycashDetail?.bookingId || pettycashDetail?.bookingCode
                }
              />
              <Detail label="City" value={pettycashDetail?.cityName} />
              <Detail label="Hub" value={pettycashDetail?.hubName} />
              <Detail label="Requested By" value={pettycashDetail?.requestBy} />
              <Detail
                label="Requested Mail"
                value={pettycashDetail?.requestByEmail}
              />
              <Detail
                label="Date"
                value={formatdate(pettycashDetail?.createdAt)}
              />
            </div>
            {/* Image */}
            {parsedAttachments.length > 0 && (
              <div>
                <p className="font-medium text-gray-800 my-2">Attachment</p>
                <img
                  className="w-full h-80 object-cover rounded-md border"
                  src={
                    parsedAttachments[0].url
                      ? parsedAttachments[0].url
                      : parsedAttachments[0].path
                  }
                  alt="Attachment"
                />
              </div>
            )}
          </div>
        </div>
      )}

      <div className="min-h-screen p-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-4 mt-6">
            <img className="w-20 h-20 rounded-full" src={user} alt="User" />
            <h1 className="text-2xl font-bold">
              Welcome back, {profile?.name}!
            </h1>
          </div>
          <div className="border flex gap-4 rounded-md">
            <h1 className="text-xl mt-2">Select Date: </h1>
            <DaterangePicker
              selectionRange={selectionRange}
              setSelectionRange={setSelectionRange}
              style={-10}
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          <FormControl fullWidth size="small">
            <InputLabel id="city-select-label">City</InputLabel>
            <Select
              labelId="city-select-label"
              id="city-select"
              value={city}
              label="City"
              onChange={handleCityChange}
            >
              {cities &&
                Object.entries(cities).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small">
            <InputLabel id="hub-select-label">Hub</InputLabel>
            <Select
              labelId="hub-select-label"
              id="hub-select"
              value={hub}
              label="Hub"
              onChange={handleHubChange}
            >
              {hubs?.length ? (
                hubs.map((item, index) => (
                  <MenuItem key={index} value={item?.id}>
                    {item?.hubName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">
                  <em>Select City First</em>
                </MenuItem>
              )}
            </Select>
          </FormControl>

          {/* <FormControl fullWidth size="small">
            <InputLabel id="status-select-label">Status</InputLabel>
            <Select
              labelId="status-select-label"
              id="status-select"
              value={statusType}
              label="Status"
              onChange={handleStatusChange}
            >
              {Object.entries(pettyCashStatusTypes)?.length ? (
                Object.entries(pettyCashStatusTypes).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">
                  <em>Select City First</em>
                </MenuItem>
              )}
            </Select>
          </FormControl> */}

          {/* <FormControl fullWidth size="small">
            <InputLabel id="category-select-label">Category</InputLabel>
            <Select
              labelId="status-select-label"
              id="category-select"
              value={categoryId}
              label="category"
              onChange={handleCategoryChange}
            >
              {Object.entries(pettyCashCategoryType)?.length ? (
                Object.entries(pettyCashCategoryType).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">
                  <em>Loading...</em>
                </MenuItem>
              )}
            </Select>
          </FormControl> */}
        </div>

        <div className="min-w-[250px] my-4">
          <Autocomplete
            fullWidth
            freeSolo
            options={userList} // Add your options here, e.g., ["ID001", "ID002"]
            getOptionLabel={(option) => {
              if (option && typeof option === "object") {
                const name = option.name || "";
                const id = option.id || "";
                const email = option?.email;
                return `${name} - ${email} - ${id}`.trim();
              }
              return "";
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Executive Id"
                InputLabelProps={{ shrink: true }}
                autoComplete="off"
                // className="h-10"
              />
            )}
            onChange={(event, newValue) => {
              setExecutiveId(newValue);
            }}
          />
        </div>

        <div className="w-full sm:w-auto flex justify-end sm:ml-auto gap-4 my-8 sm:mt-0">
          <button
            onClick={() => {
              getTableData();
            }}
            className="bg-blue-600 text-white px-6 py-2 rounded-full shadow-md hover:bg-blue-700 transition"
          >
            Search
          </button>
          {/* <button
              onClick={() => {
                setCity(null);
                setHub(null);
                setSelectionRange({
                  startDate: oneMonthAgo,
                  endDate: today,
                  key: "selection",
                });
                setExecutiveId(null)
              }}
            className="bg-red-400 text-white px-6 py-2 rounded-full shadow-md hover:bg-gray-500 transition"
          >
            Reset
          </button> */}
        </div>

        {tableData.length > 0 ? (
          <>
            <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-2xl p-6">
              {/* Agent Info */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                {[
                  { label: "Executive Name", value: executiveId?.name },
                  { label: "Executive ID", value: executiveId?.id },
                  { label: "Executive Mail", value: executiveId?.email },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="bg-gray-100 p-4 rounded-md text-center shadow"
                  >
                    <div className="text-xs text-gray-500 uppercase tracking-widest mb-1">
                      {item.label}
                    </div>
                    <div className="text-base font-semibold text-gray-800">
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>

              {/* Summary Cards */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                <div className="bg-white border-t-4 border-yellow-500 p-6 rounded-xl text-center shadow">
                  <h3 className="text-xs uppercase tracking-wider text-gray-500 mb-2">
                    Pending Requests
                  </h3>
                  <div className="text-3xl font-bold text-gray-800">
                    {totalCount}
                  </div>
                  <p className="text-sm text-gray-500">Awaiting approval</p>
                </div>
                <div className="bg-white border-t-4 border-red-500 p-6 rounded-xl text-center shadow">
                  <h3 className="text-xs uppercase tracking-wider text-gray-500 mb-2">
                    Total Amount
                  </h3>
                  <div className="text-3xl font-bold text-gray-800">
                    ₹{" "}
                    {tableData.reduce(
                      (sum, item) => sum + (item?.amount || 0),
                      0
                    )}
                  </div>
                  <p className="text-sm text-gray-500">Pending approval</p>
                </div>
              </div>
            </div>

            <div className="overflow-x-auto rounded-lg shadow mb-8">
              <div className="bg-white p-4 my-4 flex gap-4">
                <h1 className="text-2xl">Bulk Actions : </h1>
                <button
                  className="bg-blue-500 text-white px-3 py-2 rounded-full"
                  onClick={handleSelectAll}
                >
                  Select All
                </button>
                <button
                  className="bg-blue-500 text-white px-3 py-2 rounded-full"
                  onClick={handleSelectNone}
                >
                  Select None
                </button>

                {/* <button
                  onClick={() => {}}
                  className="bg-green-500 text-white px-3 py-2 rounded-full"
                >
                  Approve Request
                </button> */}
                {/* <button className="bg-red-500 text-white px-3 py-2 rounded-full">
                  Reject Request
                </button> */}
              </div>
              <table className="min-w-full text-sm bg-white">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="p-4">
                      <input
                        type="checkbox"
                        checked={selectedRows.length === tableData.length}
                        onChange={(e) =>
                          e.target.checked
                            ? handleSelectAll()
                            : handleSelectNone()
                        }
                      />
                    </th>
                    <th className="p-4 text-left">Id</th>
                    <th className="p-4 text-left">Description</th>
                    <th className="p-4 text-left">Amount</th>
                    <th className="p-4 text-left">Category</th>
                    <th className="p-4 text-left">Sub Category</th>
                    <th className="p-4 text-left">Date</th>
                    <th className="p-4 text-left">Status</th>
                    <th className="p-4 text-left">Image</th>
                    <th className="p-4 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((req, idx) => (
                    <tr
                      key={idx}
                      className="border-b last:border-b-0 hover:bg-gray-50 transition"
                    >
                      <td className="p-4">
                        <input
                          type="checkbox"
                          checked={isSelected(req.id)}
                          onChange={() =>
                            toggleRowSelection(req.id, req.amount)
                          }
                        />
                      </td>
                      <td className="p-4">
                        <td className="font-semibold text-gray-800">
                          {req.id}
                        </td>
                      </td>
                      <td className="text-gray-500 text-xs w-40">
                        {req.description}
                      </td>
                      <td className="p-4 font-bold text-red-600">
                        {req.amount}
                      </td>
                      <td className="p-4">
                        <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                          {pettyCashCategoryType[req.cashFor] || "N/A"}
                        </span>
                      </td>
                      <td className="p-4">
                        <span className="bg-purple-300 text-green-800 text-xs px-2 py-1 rounded-full">
                          {subCategory.find(
                            (item) => item.id === Number(req.subCategory)
                          )?.value || "N/A"}
                        </span>
                      </td>
                      <td className="p-4 text-sm text-gray-700">
                        <td>{formatdate(req.createdAt)}</td>
                        <td className="text-xs text-gray-400">{req.time}</td>
                      </td>
                      <td className="p-4">
                        <span className="bg-yellow-100 text-yellow-700 px-2 py-1 text-xs rounded-full">
                          {pettyCashStatusTypes[req.pettyCashStatus]}
                        </span>
                      </td>
                      <td className="p-4">
                        <img
                          src={
                            JSON.parse(req.attachments)[0]?.url
                              ? JSON.parse(req.attachments)[0]?.url
                              : JSON.parse(req.attachments)[0]?.path
                          }
                          className="bg-yellow-100 w-18 h-14 text-yellow-700 px-2 py-1 text-xs"
                        />
                      </td>
                      <td className="p-4 space-x-2">
                        <button
                          onClick={() => {
                            setShowDrawer(true);
                            viewPettycashDetail(req.id);
                          }}
                          className="text-blue-600 hover:underline text-sm"
                        >
                          View
                        </button>
                        {/* <button
                          onClick={() => {
                            handleReject(
                              pettyCashStatusTypes?.inverted?.rejected,
                              req
                            );
                          }}
                          className="text-red-600 hover:underline text-sm"
                        >
                          ✗ Reject
                        </button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="bg-white rounded-xl p-6 shadow mb-8">
              <div className="flex justify-between my-2">
                <h2 className="text-xl font-bold mb-4">Cash Transaction</h2>
                <p className="bg-red-600 rounded-lg p-3 text-lg font-medium text-white">
                  Selected Amount -{" "}
                  <span>
                    {selectedAmount.reduce((sum, value) => sum + value, 0)}
                  </span>
                </p>
              </div>
              <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="mb-1 font-semibold">Amount Given (₹)</label>
                  <input
                    type="number"
                    className="border p-2 rounded-md"
                    required
                    onChange={(e) => {
                      setInputValues((prev) => ({
                        ...prev,
                        amount: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="mb-1 font-semibold">Payment Method *</label>
                  <select
                    onChange={(e) => {
                      setInputValues((prev) => ({
                        ...prev,
                        paymentmethod: e.target.value,
                      }));
                    }}
                    className="border p-2 rounded-md"
                    required
                  >
                    <option value="">Select Payment method</option>
                    {Object.entries(modeofPayments).map(([key, value]) => {
                      return <option value={value}>{value}</option>;
                    })}
                  </select>
                </div>
                <div className="flex flex-col">
                  <label className="mb-1 font-semibold">Transaction Id</label>
                  <input
                    onChange={(e) => {
                      setInputValues((prev) => ({
                        ...prev,
                        transactionid: e.target.value,
                      }));
                    }}
                    type="text"
                    className="border p-2 rounded-md"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="mb-1 font-semibold">
                    Transaction Notes
                  </label>
                  <textarea
                    onChange={(e) => {
                      setInputValues((prev) => ({
                        ...prev,
                        transactionnote: e.target.value,
                      }));
                    }}
                    className="border p-2 rounded-md w-full"
                    rows="3"
                  ></textarea>
                </div>
                {/* <div className="flex flex-col">
                  <label className="mb-1 font-semibold">Approved By *</label>
                  <input
                    type="text"
                    className="border p-2 rounded-md"
                    required
                  />
                </div>
                <div className="flex flex-col">
                  <label className="mb-1 font-semibold">Received By</label>
                  <input type="text" className="border p-2 rounded-md" />
                </div> */}
                <div className="flex flex-col">
                  <label className="mb-1 font-semibold">Attachment</label>
                  {transactionImage && (
                    <img className="w-44 h-44" src={transactionImage[0]?.url} />
                  )}
                  <input
                    onChange={(event) => [handleUploadImage(event)]}
                    type="file"
                    className="border p-2 rounded-md"
                  />
                </div>
                <div className="md:col-span-2 flex gap-4 justify-end mt-4">
                  <button
                    type="reset"
                    onClick={() => {
                      setInputValues(null);
                      setTransactionImage(null);
                    }}
                    className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    onClick={(e) => {
                      addTransaction(e);
                    }}
                    className="bg-blue-800 text-white px-4 py-2 rounded-md hover:bg-blue-800"
                  >
                    Record Transaction
                  </button>
                </div>
              </form>
            </div>

            {/* <div className="flex gap-8 mt-4 p-4">
              <TextField
                sx={{
                  width: "75%",
                }}
                label="Description"
                variant="outlined"
                onChange={(e) => setComment(e.target.value)}
              />
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#036615ff",
                  "&:hover": { backgroundColor: "#084926ff" },
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  fontWeight: "bold",
                  // my: 2,
                }}
                onClick={() =>
                  handleApproveCashRequest(
                    pettyCashStatusTypes?.inverted?.cashCompleted
                  )
                }
              >
                Cash Completed
              </Button>
            </div> */}
          </>
        ) : (
          <div className="text-center text-2xl my-4">
            Search by Executives for the bulk approval
          </div>
        )}
      </div>
    </>
  );
};

export default Bulkapproval;
